import { createContext } from 'react';

const defaultContext = {
  brandId: -1,
  setBrandId: (id: number) => console.log(`brand id is ${id} in provider.`),
  showBulkOrdersJobModal: () => console.log('show bulk orders job modal.'),
  triggerBulkOrdersJob: () => console.log('trigger bulk orders job.'),
};
export const AppContext = createContext(defaultContext);
